// extracted by mini-css-extract-plugin
export default {"fields":"FieldsLayout_fields__Q9UM1"};